import { render, staticRenderFns } from "./ExchangeGood.vue?vue&type=template&id=6be90a5b&scoped=true&"
import script from "./ExchangeGood.vue?vue&type=script&lang=ts&"
export * from "./ExchangeGood.vue?vue&type=script&lang=ts&"
import style0 from "./ExchangeGood.vue?vue&type=style&index=0&id=6be90a5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be90a5b",
  null
  
)

export default component.exports